var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.432 1.079a1.25 1.25 0 0 0-2.033.391L9.64 5.575a4.25 4.25 0 0 0-4.215 1.07L4.067 8a.75.75 0 0 0 0 1.06l2.142 2.143-5.74 5.739a.75.75 0 1 0 1.061 1.06l5.74-5.739 2.141 2.142a.75.75 0 0 0 1.061 0l1.357-1.356a4.249 4.249 0 0 0 1.069-4.217l4.105-1.76a1.25 1.25 0 0 0 .392-2.032l-3.963-3.96Z",
    fill: "#377DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPin);
export default __webpack_public_path__ + "static/media/ic_pin.249de3ea119c749fb26e456abbf9a324.svg";
export { ForwardRef as ReactComponent };